import { isUs } from '@/globalConsts';

export const genderOptions = [
	{ label: 'Male', value: 'male' },
	{ label: 'Female', value: 'female' },
	{ label: 'Other', value: 'other' },
	{ label: 'Unknown', value: 'unknown' },
];

export const registrationLegalSexOptions = [
	{ label: 'Male', value: 'male' },
	{ label: 'Female', value: 'female' },
	// Value is 'other', but the backend maps it to 'intersex' which is what we store in the db.
	{ label: isUs ? 'Other' : 'Intersex', value: 'other' },
];

export const legalSexOptions = [
	{ label: 'Male', value: 'male' },
	{ label: 'Female', value: 'female' },
	{ label: isUs ? 'Other' : 'Intersex', value: 'intersex' },
	{ label: 'Unknown', value: 'unknown' },
];

export const statusOptions = [
	{ label: 'Approved', value: '500' },
	{ label: 'Candidate', value: '100' },
	{ label: 'Completed', value: '1000' },
	{ label: 'Consent Delegated', value: '530' },
	{ label: 'Consent Pending', value: '540' },
	{ label: 'Consented', value: '550' },
	{ label: 'Device Dispatched', value: '560' },
	{ label: 'Engaged', value: '520' },
	{ label: 'Enrolled', value: '650' },
	{ label: 'Off Boarding', value: '900' },
	{ label: 'Prospect', value: '70' },
	{ label: 'Randomised', value: '610' },
	{ label: 'Ready To Engage', value: '510' },
	{ label: 'Re-screening required', value: '580' },
	{ label: 'Screened', value: '600' },
	{ label: 'StudySite Contacted', value: '602' },
	{ label: 'StudySite Scheduled', value: '604' },
	{ label: 'StudySite Screening', value: '606' },
	{ label: 'Trained', value: '800' },
];

export const surveyStatusOptions = [
	{ label: 'Sent', value: 'sent' },
	{ label: 'Scheduled', value: 'scheduled' },
	{ label: 'Completed', value: 'completed' },
];

export const surveyFilterOptions = [
	{
		label: 'Include',
		value: 'include',
		statusColor: 'hsla(159, 93%, 33%, 1)',
	},
	{
		label: 'Exclude',
		value: 'exclude',
		statusColor: 'hsla(356, 93%, 47%, 1)',
	},
];

export const contactFilterOptions = [
	{
		label: 'has',
		value: 'false',
	},
	{
		label: 'does not have',
		value: 'true',
	},
];

export const contactTypeFilterOptions = [
	{
		label: 'Email',
		value: 'email',
	},
	{
		label: 'Mobile',
		value: 'phone_mobile',
	},
	{
		label: 'Home phone',
		value: 'phone_home',
	},
];

export const contactMethodOptions = [
	{ label: 'Email', value: 'email' },
	{ label: 'SMS', value: 'sms' },
	{ label: 'Home Phone Call', value: 'home_phone_call' },
	{ label: 'Mobile Phone Call', value: 'mobile_phone_call' },
	{ label: 'Follow Up', value: 'follow_up' },
];
